import Panel from "components/layout/panel";
import View from "components/layout/view";
import Markdown from "components/markdown";
import UserNavigation from "components/user-navigation/user-navigation";
import { useList } from "stores/hooks/list";
import { useLocale } from "stores/hooks/locale";
import { parse } from "lib/locale";
import { ListObligation } from "models/list-obligation";
import { useEffect, useState } from "react";
import { userDoGetListObligation } from "services/user/list-obligation";
import {
  userDoGetObligation,
  userDoPostObligation,
} from "services/user/obligation";
import ListObligationForm from "./form";
import { useListEntities } from "stores/hooks/list-entities";
import { useNavigate } from "react-router";
import Title from "components/title";
import UserStatus from "components/user-navigation/user-status";

const UserListObligationView = () => {
  const [listObligation, toggleListObligation] = useState<
    ListObligation | undefined
  >(undefined);
  const [userObligation, toggleUserObligation] = useState<boolean | undefined>(
    undefined,
  );
  const list = useList();
  const [firstEntity] = useListEntities();
  const locale = useLocale();
  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      if (!list) {
        return;
      }

      // get list obligation and users confirmation
      const listObligation = await userDoGetListObligation(list.uuid);
      toggleListObligation(listObligation);

      // get user obligation
      try {
        await userDoGetObligation();
        toggleUserObligation(true);
      } catch (err) {
        toggleUserObligation(false);
      }
    };
    fetch();
  }, [list?.uuid]);

  if (!list || !listObligation || userObligation === undefined) {
    return;
  }

  const title = ["Velvoitteet", parse(list.name, locale)].join(" | ");
  return (
    <View title={title} navigation={false}>
      <UserNavigation />
      <Panel>
        <Title>Velvoitteet</Title>
        <Markdown>{parse(listObligation.text, locale)}</Markdown>
        <ListObligationForm
          agree={userObligation === true}
          onSubmit={async (_values) => {
            await userDoPostObligation();
            navigate(`/user/list/${list?.uuid}/entity/${firstEntity.uuid}`);
          }}
        />
        <UserStatus />
      </Panel>
    </View>
  );
};

export default UserListObligationView;
